import React from 'react';
import { Author } from '@interfaces/IUser';
import css from './UserShortCard.module.less';
import Avatar from '@components/Avatar';

interface UserShortCardProps<T extends Author> {
  user: T;
  onClick?: () => void;
}

const UserShortCard = <T extends Author>({ user, onClick }: UserShortCardProps<T>) => (
  <div className={css.root}>
    <Avatar
      user={user}
      className='clickable'
      onClick={onClick}
    />
    <a
      className='clickable'
      href={`/user-list/${user?.id}`}
      target='_blank'
      rel='noreferrer'
    >
      {user?.nickname}
    </a>
  </div>
);

export default UserShortCard;
